
<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>OnBoarding Sayfası Ekle</h4>
      <v-row style="margin-top:50px;">
        <v-col cols="12" md="4">
          <h4>Resim <span style="color:red;">(296 × 269)</span></h4>
          <v-img
            style="cursor:pointer;"
            v-if="imgUrl!='' && imgUrl!=undefined"
            :src="imgUrl"
            aspect-ratio="1.7"
          ></v-img>
          <!-- <v-text-field v-model="onBoardingData.imgUrl" :rules="imgUrlRules" required></v-text-field> -->
          <v-file-input
            show-size
            accept="image/*"
            v-model="onBoardingData.img"
            @change="previewFiles"
            label="Resim yükle"
            required
          ></v-file-input>
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <v-col cols="12" md="4">
          <h4>
            Animasyon
            <v-icon style="font-size:17px;" v-if="!alert" color="#4d48f9" @click="alert = true">info</v-icon>

            <v-alert
              v-model="alert"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >Animasyonlar json formatında girilmelidir.</v-alert>
          </h4>
          <v-file-input
            show-size
            accept="application/json"
            v-model="onBoardingData.animation"
            label="Animasyon yükle"
            required
          ></v-file-input>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Başlık</h4>
          <v-text-field
            v-model="onBoardingData.title"
            maxlength="255"
            counter="255"
            :rules="titleRules"
            required
            name="input-7-1"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="12">
          <h4>Açıklama</h4>
          <v-textarea
            v-model="onBoardingData.description"
            maxlength="255"
            counter="255"
            rows="1"
            auto-grow
            :rules="descriptionRules"
            required
            name="input-7-1"
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Link</h4>
          <v-text-field v-model="onBoardingData.link" required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Link Metni</h4>
          <v-text-field v-model="onBoardingData.linkText" required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Sıralama</h4>
          <v-text-field
            v-model="onBoardingData.ordering"
            type="number"
            min="0"
            :rules="orderRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important;float:right;color:white;"
            @click="onBoardingAdd()"
          >EKLE</v-btn>
        </v-col>
      </v-row>

      <v-dialog
              v-model="dialog"
              max-width="600"
      >
        <v-card>
          <v-card-title class="headline">Lütfen alanları kontrol edin</v-card-title>

          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{fruit}}</li>
            </ul>
          </v-card-text>

        </v-card>
      </v-dialog>
      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import {  mapActions } from "vuex";

export default {
  name: "OnBoarding",
  methods: {
        ...mapActions(["addOnBoarding"]),
    routeUsers() {
      this.$router.push("/dashboard/onBoardings");
    },
    onBoardingAdd() {
      if (
        this.$refs.form.validate() 
      ) {
        this.snackbar = true;
        console.log("data", this.onBoardingData);
        if((this.onBoardingData.img==null || this.onBoardingData.img == undefined) && (this.onBoardingData.animation==null || this.onBoardingData.animation == undefined)) {
          alert("Resim ve animasyon alanlarından en az bir tanesi doldurulmalıdır.");
          return;
        }
        console.log("on",this.onBoardingData);
        this.addOnBoarding(this.onBoardingData).then(response=>{
          console.log(response)
          if(response.processStatus == "Success") {
            this.$router.push('/dashboard/onBoardings');
          }
        }).catch(err=>{
          alert(err);
        });
      }else{
        var errors=[];
        var x = document.getElementsByClassName("v-messages__message");
        for (var i = 0; i < x.length; i++)
          errors.push(x[i].innerHTML);

        this.errorList=errors;

        this.dialog=true;
      }
    },
        previewFiles(){
      console.log("img",this.imgUrl);
      if(this.onBoardingData.img == undefined) {
        this.imgUrl = '';
      }
      else {
      const file = this.onBoardingData.img;
      this.imgUrl = URL.createObjectURL(file);
      }
    },
  },
  data: () => ({
    alert:false,
    onBoardingData: {
      img: null,
      title: "",
      description: "",
      link: "",
      linkText:"",
      order: 0,
      animation:null
    },
    valid: true,
    imgUrl:'',
    titleRules: [
      v => !!v || "Başlık alanı zorunludur.",
      v => v.trim().length > 0 || "Başlık alanı zorunludur.",
      v => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    descriptionRules: [
      v => !!v || "Açıklama alanı zorunludur.",
      v => v.trim().length > 0 || "Açıklama alanı zorunludur.",
      v => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    orderRules: [
      v => parseFloat(v) > -1 || "Sıralama 0'dan küçük olmamalıdır."
    ],
      fileRules: [
      // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
      v => !!v || "Resim gereklidir.",
      v => (v && v.name != null) || "Resim gereklidir."
    ],
    errorList:[],
    dialog:false
  }),
};
</script>
